let tables = [
    //设备监控
    //地图总览
    {
        path: '/MapView',
        name: 'MapView',
        component: () => import('@/views/device/DeviceMonitor/MapView.vue')
    },
    //设备总览
    {
        path: '/DeviceView',
        name: 'DeviceView',
        component: () => import('@/views/device/DeviceMonitor/DeviceView.vue')
    },
    //设备详情
    {
        path: '/DeciveDetail',
        name: 'DeciveDetail',
        component: () => import('@/views/device/DeviceMonitor/DeciveDetail.vue')
    },
    //数据分析-->历史曲线
    {
        path: '/HistoryView',
        name: 'HistoryView',
        component: () => import('@/views/device/DeviceMonitor/DataAnalysis/HistoryView.vue')
    },
    //数据分析-->报表分析
    {
        path: '/ReportAna',
        name: 'ReportAna',
        component: () => import('@/views/device/DeviceMonitor/DataAnalysis/ReportAna.vue')
    },
    //设备管理
    //设备台账
    {
        path: '/Dev_DeviceLedger',
        name: 'Dev_DeviceLedger',
        component: () => import('@/views/device/device/deviceman/Dev_DeviceLedger.vue')
    },
    //设备文档
    {
        path: '/Dev_DeviceDocument',
        name: 'Dev_DeviceDocument',
        component: () => import('@/views/device/device/deviceman/Dev_DeviceDocument.vue')
    },
    //设备绩效
    {
        path: '/DevicePerfomMonitor',
        name: 'DevicePerfomMonitor',
        component: () => import('@/views/device/DevicePerform/DevicePerfomMonitor.vue')
    },
    //OEE
    //班别管理
    {
        path: '/Dev_Class',
        name: 'Dev_Class',
        component: () => import('@/views/device/device/oee/Dev_Class.vue')
    },
    //参数设置生成页面
    {
        path: '/Dev_StatusType',
        name: 'Dev_StatusType',
        component: () => import('@/views/device/device/oee/Dev_StatusType.vue')
    },
    //参数设置
    {
        path: '/ParamSet',
        name: 'ParamSet',
        component: () => import('@/views/device/device/oee/ParamSet.vue')
    },
    //绩效总览
    {
        path: '/OEEOverview',
        name: 'OEEOverview',
        component: () => import('@/views/device/device/oee/OEEOverview.vue')
    },
    //设备实时绩效
    {
        path: '/DevRealOEE',
        name: 'DevRealOEE',
        component: () => import('@/views/device/device/oee/DevRealOEE.vue')
    },
    //稼动率分析
    {
        path: '/AvailabilityAna',
        name: 'AvailabilityAna',
        component: () => import('@/views/device/device/oee/AvailabilityAna.vue')
    },
    //OEE测试
    {
        path: '/DevOEETest',
        name: 'DevOEETest',
        component: () => import('@/views/device/device/oee/DevOEETest.vue')
    },
    //设备监控
    //实时监控
    {
        path: '/RealTimeMonitor',
        name: 'RealTimeMonitor',
        component: () => import('@/views/device/KG_DeviceMonitor/RealTimeMonitor.vue')
    },
    //历史记录
    {
        path: '/HistoryMonitor',
        name: 'HistoryMonitor',
        component: () => import('@/views/device/KG_DeviceMonitor/HistoryMonitor.vue')
    },
    //看板
    {
        path: '/Dashboard',
        name: 'Dashboard',
        component: () => import('@/views/device/DeviceMonitor/Dashboard.vue')
    },
]
export default tables;
